import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMessageBox } from '../components/MessageBoxContainer';
import HelpButton from '../components/HelpButton';
import '../styles/VotingPage.css';

const VotingPage = () => {
  const navigate = useNavigate();
  const messageBox = useMessageBox();
  const [step, setStep] = useState(1); // 1: faculty selection, 2: major selection, 3: candidates, 4: credentials
  const [selectedFaculty, setSelectedFaculty] = useState(null);
  const [selectedMajor, setSelectedMajor] = useState(null);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [studentId, setStudentId] = useState('');
  const [nationalId, setNationalId] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Check voting time on mount
  useEffect(() => {
    const votingStartTime = new Date('2025-11-23T09:00:00');
    const votingEndTime = new Date('2025-11-25T18:00:00');
    const now = new Date();

    if (now < votingStartTime) {
      alert('رای‌گیری هنوز شروع نشده است!\n\nرای‌گیری از روز یکشنبه ۲ آذر ۱۴۰۴ ساعت ۹:۰۰ صبح شروع می‌شود.');
      navigate('/');
      return;
    }

    if (now > votingEndTime) {
      alert('رای‌گیری پایان یافته است!\n\nزمان رای‌گیری به پایان رسیده است. لطفاً نتایج را مشاهده کنید.');
      navigate('/results');
      return;
    }
  }, [navigate]);

  // Scroll to top when component mounts or step changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [step]);

  const facultiesData = {
    engineering: {
      name: 'دانشکده فنی و مهندسی',
      icon: 'cogs',
      color: '#3B82F6',
      majors: [
        {
          id: 'computer',
          name: 'مهندسی کامپیوتر',
          icon: 'laptop-code',
          color: '#3B82F6',
          candidates: [
            { id: 1, name: 'علی محمد شاه‌حسینی', gender: 'male', photo: 'https://i.postimg.cc/HnRwp5jb/IMG-20251119-223955-992.jpg' },
            { id: 2, name: 'عرفان تبار‌ملاحسن', gender: 'male', photo: 'https://i.postimg.cc/g0YQCr7X/IMG-20251117-140951-442.jpg' },
            { id: 3, name: 'نگار توسلی', gender: 'female', photo: 'https://i.postimg.cc/pTQfxpDM/IMG-20251114-215112-735.jpg' },
            { id: 4, name: 'زهرا محمدی', gender: 'female', photo: null },
            { id: 5, name: 'هادی مستوفی‌زاده', gender: 'male', photo: 'https://i.postimg.cc/d1R2vLGB/IMG-20251114-215051-745.jpg' },
            { id: 6, name: 'نیوشا اللّه‌دادی', gender: 'female', photo: 'https://i.postimg.cc/4xbZF73j/4960986466301446957.jpg' },
            { id: 7, name: 'ابوالفضل علیزاده', gender: 'male', photo: 'https://i.postimg.cc/ZRP8ZC6x/IMG-20251114-184832-710.jpg' },
            { id: 8, name: 'علی اصغر اقبال', gender: 'male', photo: 'https://i.postimg.cc/Jn3NmGj3/IMG-20251114-215051-903.jpg' },
            { id: 9, name: 'ابوالفضل اصغری', gender: 'male', photo: 'https://i.postimg.cc/Hx0wHVb3/IMG-20251114-215052-393.jpg' }
          ]
        },
        {
          id: 'chemical',
          name: 'مهندسی شیمی',
          icon: 'flask',
          color: '#F59E0B',
          candidates: [
            { id: 10, name: 'ابوالفضل قربانی', gender: 'male', photo: 'https://i.postimg.cc/MTRgWrf6/IMG-5158.jpg' },
            { id: 11, name: 'امیر یزدان‌ پناه', gender: 'male', photo: null },
            { id: 12, name: 'مهدی علیزاده', gender: 'male', photo: 'https://i.postimg.cc/zvJnf8k6/IMG-20251114-215101-412.jpg' },
            { id: 13, name: 'شقایق صادقی', gender: 'female', photo: null },
            { id: 14, name: 'فاطمه نعیمی', gender: 'female', photo: 'https://i.postimg.cc/xdwQFv2j/5821451858038426580.jpg' },
            { id: 15, name: 'محمدفاضل ولی پور', gender: 'male', photo: 'https://i.postimg.cc/0jF2xTgV/5823327354292472698.jpg' },
            { id: 16, name: 'پارمیدا حبیبی شور کچالی', gender: 'female', photo: 'https://i.postimg.cc/KcLPVxng/5823272288516770569.jpg' },
            { id: 17, name: 'ماهک عنایتی', gender: 'female', photo: null },
            { id: 18, name: 'عرشیا وحیدی', gender: 'male', photo: 'https://i.postimg.cc/rwq7sh8G/4960986466301446955.jpg' },
            { id: 19, name: 'کیانا نجف نژاد', gender: 'female', photo: 'https://i.postimg.cc/0j8pNPfx/IMG-20251114-215111-717.jpg' }
          ]
        },
        {
          id: 'architecture',
          name: 'مهندسی معماری',
          icon: 'drafting-compass',
          color: '#10B981',
          candidates: [
            { id: 20, name: 'رضا بیاتی', gender: 'male', photo: null },
            { id: 21, name: 'سیده فاطمه حسینی', gender: 'female', photo: 'https://i.postimg.cc/SKJrxkLx/IMG000-(1).jpg' },
            { id: 22, name: 'آرزو رسولی', gender: 'female', photo: null },
            { id: 23, name: 'نادیا شرامه', gender: 'female', photo: null },
            { id: 24, name: 'یلدا زندی زیارانی', gender: 'female', photo: null },
            { id: 105, name: 'مهدی رمضانی', gender: 'male', photo: null },
            { id: 106, name: 'مریم رزقی', gender: 'female', photo: null },
            { id: 107, name: 'پرستو ولی', gender: 'female', photo: null },
            { id: 108, name: 'هلیا پارسایان', gender: 'female', photo: null },
            { id: 109, name: 'معصومه معینی', gender: 'female', photo: null },
            { id: 110, name: 'رومینا حسین‌زاده', gender: 'female', photo: null },
            { id: 111, name: 'معصومه ازوی', gender: 'female', photo: null }
          ]
        },
        {
          id: 'mechanical',
          name: 'مهندسی مکانیک',
          icon: 'cogs',
          color: '#EC4899',
          candidates: [
            { id: 25, name: 'محمد رسول قربانی', gender: 'male', photo: null },
            { id: 26, name: 'مهدی ایمانی', gender: 'male', photo: 'https://i.postimg.cc/QNbtVzD2/5819017388970675257.jpg' },
            { id: 27, name: 'حامد یزدانی', gender: 'male', photo: 'https://i.postimg.cc/tTFsrRLJ/5819211972464020467.jpg' },
            { id: 28, name: 'میثم ابراهیم پور ملکشاه', gender: 'male', photo: null },
            { id: 29, name: 'محمد رنجبر', gender: 'male', photo: 'https://i.postimg.cc/Wz2M4TnD/IMG-20251114-215110-259.jpg' }
          ]
        },
        {
          id: 'civil',
          name: 'مهندسی عمران',
          icon: 'building',
          color: '#8B5CF6',
          candidates: [
            { id: 30, name: 'امیررضا اکبری', gender: 'male', photo: null },
            { id: 31, name: 'هدیه شکیبایی مرام', gender: 'female', photo: null },
            { id: 32, name: 'مهدی اجواری', gender: 'male', photo: 'https://i.postimg.cc/1XJDn2C0/IMG-20251114-215118-844.jpg' },
            { id: 33, name: 'امیرمحمد جوکار', gender: 'male', photo: 'https://i.postimg.cc/2y2nbMcL/IMG-20251114-215117-471.jpg' },
            { id: 34, name: 'مهدیسا آقاگلی', gender: 'female', photo: null },
            { id: 35, name: 'علی فرهادی', gender: 'male', photo: null },
            { id: 37, name: 'سید محمد یاسین حسنی', gender: 'male', photo: null },
            { id: 38, name: 'سهیل تقوی', gender: 'male', photo: null },
            { id: 39, name: 'امیرحسین رضایی', gender: 'male', photo: null },
            { id: 40, name: 'فریبرز علایی', gender: 'male', photo: null }
          ]
        },
        {
          id: 'industrial',
          name: 'مهندسی صنایع',
          icon: 'industry',
          color: '#06B6D4',
          candidates: [
            { id: 41, name: 'مریم شهروزی', gender: 'female', photo: null },
            { id: 42, name: 'پارسا شایان فر', gender: 'male', photo: null },
            { id: 43, name: 'ابوالفضل احمدی', gender: 'male', photo: null },
            { id: 44, name: 'مریم رضازاده', gender: 'female', photo: null },
            { id: 45, name: 'امیرحسین غلامی بایی', gender: 'male', photo: null },
            { id: 46, name: 'نوید رضا قلی زاده', gender: 'male', photo: null }
          ]
        },
        {
          id: 'biomedical',
          name: 'برق-پزشکی',
          icon: 'heartbeat',
          color: '#EF4444',
          candidates: [
            { id: 47, name: 'امیررضا اکبرزاده', gender: 'male', photo: 'https://i.postimg.cc/RhCRtCSv/IMG-20251122-184946-734.jpg' },
            { id: 48, name: 'محمدجواد پناه', gender: 'male', photo: 'https://i.postimg.cc/yY7BKvgQ/IMG-20251123-112749-618.jpg' },
            { id: 49, name: 'پرستو بابایی', gender: 'female', photo: 'https://i.postimg.cc/mkbQrBws/IMG-20251114-215107-446.jpg' },
            { id: 50, name: 'کوثر نجفی مرزان', gender: 'female', photo: 'https://i.postimg.cc/L5NjYwCD/IMG-20251114-215121-705.jpg' },
            { id: 51, name: 'فاطمه زهرا ثقفی', gender: 'female', photo: null },
            { id: 112, name: 'محمد قاسمی', gender: 'male', photo: null },
            { id: 113, name: 'روناز مینا خانی', gender: 'female', photo: null },
            { id: 114, name: 'فاطمه رمضانی', gender: 'female', photo: null },
            { id: 115, name: 'فاطمه زهرا موسوی کنتی', gender: 'female', photo: null },
            { id: 116, name: 'امیر حسین رحمانی', gender: 'male', photo: null },
            { id: 117, name: 'امیر رضا شهابی', gender: 'male', photo: null },
            { id: 118, name: 'مهدی ابو طالبی', gender: 'male', photo: 'https://i.postimg.cc/4yZjcw6x/5825440542626614132.jpg' },
            { id: 119, name: 'امیر علی پور اسحاق', gender: 'male', photo: 'https://i.postimg.cc/d3vgCn2w/5823281896358612216.jpg' }
          ]
        },
        {
          id: 'surveying',
          name: 'مهندسی نقشه‌برداری',
          icon: 'map-marked-alt',
          color: '#F97316',
          candidates: [
            { id: 52, name: 'امیرحسین اسدی', gender: 'male', photo: null },
            { id: 53, name: 'حسین قنبری گنگرکلا', gender: 'male', photo: null },
            { id: 54, name: 'سام موسوی', gender: 'male', photo: null },
            { id: 55, name: 'فاطمه زهرا پرتوی', gender: 'female', photo: null },
            { id: 56, name: 'رضوان فلاحی مقدم', gender: 'male', photo: null },
            { id: 57, name: 'طهورا حجازی مرزنگو', gender: 'female', photo: null },
            { id: 58, name: 'رایکا کاویان پور', gender: 'female', photo: null }
          ]
        }
      ]
    },
    humanities: {
      name: 'دانشکده علوم انسانی',
      icon: 'book',
      color: '#10B981',
      majors: [
        {
          id: 'management',
          name: 'مدیریت',
          icon: 'briefcase',
          color: '#3B82F6',
          candidates: [
            { id: 60, name: 'امیرحسین یزدانی', gender: 'male', photo: null },
            { id: 61, name: 'علی حسین‌زاده', gender: 'male', photo: null },
            { id: 62, name: 'سید محمد حسینی', gender: 'male', photo: null },
            { id: 63, name: 'سمانه حاجی‌پور', gender: 'female', photo: null },
            { id: 64, name: 'ملیسا اصغری', gender: 'female', photo: null },
            { id: 65, name: 'بیتا اصغری', gender: 'female', photo: null },
            { id: 66, name: 'دنیا فتح‌الله‌پور', gender: 'female', photo: null },
            { id: 120, name: 'سیده ماهان طباطبایی', gender: 'female', photo: null }
          ]
        },
        {
          id: 'psychology',
          name: 'روانشناسی',
          icon: 'brain',
          color: '#F59E0B',
          candidates: [
            { id: 71, name: 'آنیتا خاکپور', gender: 'female', photo: null },
            { id: 72, name: 'ماهتیسا قنبری', gender: 'female', photo: null },
            { id: 73, name: 'پویا موخر', gender: 'male', photo: null },
            { id: 74, name: 'سپیده عسگری', gender: 'female', photo: null },
            { id: 75, name: 'فاطمه سعادتی', gender: 'female', photo: null },
            { id: 76, name: 'نسیم عابدی', gender: 'female', photo: null },
            { id: 77, name: 'فاطمه طهماسب', gender: 'female', photo: null },
            { id: 121, name: 'ساجده عباسی', gender: 'female', photo: null }
          ]
        },
        {
          id: 'accounting',
          name: 'حسابداری',
          icon: 'calculator',
          color: '#10B981',
          candidates: [
            { id: 78, name: 'سید مهدی حسینی ایمنی', gender: 'male', photo: null },
            { id: 79, name: 'محمد حسین یزدی', gender: 'male', photo: null },
            { id: 80, name: 'محمد امین کریمی', gender: 'male', photo: null },
            { id: 81, name: 'مهدی موسوی چاشمی', gender: 'male', photo: null },
            { id: 82, name: 'شراگیم للهی حاجی دلایی', gender: 'male', photo: null },
            { id: 122, name: 'زهرا ابراهیمی', gender: 'female', photo: null },
            { id: 123, name: 'محمد حسین مختاری', gender: 'male', photo: null }
          ]
        },
        {
          id: 'law',
          name: 'حقوق',
          icon: 'balance-scale',
          color: '#EF4444',
          candidates: [
            { id: 87, name: 'سحر احمدزاده', gender: 'female', photo: null },
            { id: 88, name: 'رضا توسلی', gender: 'male', photo: 'https://i.postimg.cc/tJXhgp5V/IMG-20251114-215108-762.jpg' },
            { id: 89, name: 'حنانه دلفان آذری', gender: 'female', photo: 'https://i.postimg.cc/2y2nbMc9/IMG-20251114-215133-970.jpg' },
            { id: 90, name: 'فاطمه خضرایی', gender: 'female', photo: null },
            { id: 91, name: 'ستایش وحیدی', gender: 'female', photo: null },
            { id: 92, name: 'مهنا زمینی', gender: 'female', photo: null },
            { id: 93, name: 'آرمان علی‌بابایی', gender: 'male', photo: null },
            { id: 94, name: 'حسن توکلی', gender: 'male', photo: null },
            { id: 95, name: 'ابوالفضل قلی‌نژاد عمران', gender: 'male', photo: 'https://i.postimg.cc/Fz9jKNZk/IMG-20251114-215113-308.jpg' },
            { id: 96, name: 'سپهر جعفری', gender: 'male', photo: 'https://i.postimg.cc/nrHvLpkV/IMG-20251114-215103-644.jpg' },
            { id: 124, name: 'محمد شکری زاده', gender: 'male', photo: 'https://i.postimg.cc/C1fKhbTC/IMG-3532.avif' },
            { id: 125, name: 'محمد طاها عباسی', gender: 'male', photo: 'https://i.postimg.cc/VvQkd5m3/5805312139739204744.jpg' }
          ]
        }
      ]
    },
    sports: {
      name: 'دانشکده علوم ورزشی',
      icon: 'running',
      color: '#EC4899',
      majors: [
        {
          id: 'physical',
          name: 'تربیت بدنی و علوم ورزشی',
          icon: 'running',
          color: '#8B5CF6',
          candidates: [
            { id: 97, name: 'سارینا صانعی ماتک', gender: 'female', photo: 'https://i.postimg.cc/prqKh4Gr/IMG-20251114-215102-768.jpg' },
            { id: 98, name: 'سیده فاطمه تقوی', gender: 'female', photo: null },
            { id: 99, name: 'زهرا رضایی', gender: 'female', photo: 'https://i.postimg.cc/rFg216Y8/5821060968769850376.jpg' },
            { id: 100, name: 'نرجس غلامی', gender: 'female', photo: null },
            { id: 101, name: 'عرفان بهنام', gender: 'male', photo: 'https://i.postimg.cc/pyMbsRML/5825815072364760288.jpg' },
            { id: 102, name: 'سجاد زارع', gender: 'male', photo: null },
            { id: 103, name: 'ماهان تقی پور', gender: 'male', photo: 'https://i.postimg.cc/hvpVz6yp/IMG-20251114-215119-732.jpg' },
            { id: 104, name: 'سید حسین حسینی', gender: 'male', photo: 'https://i.postimg.cc/nrVkmVFt/IMG-20251122-185157-052.jpg' }
          ]
        }
      ]
    }
  };

  const handleFacultySelect = (facultyKey) => {
    setSelectedFaculty(facultyKey);
    setSelectedMajor(null);
    setSelectedCandidates([]);
    setStep(2);
  };

  const handleMajorSelect = (majorId) => {
    setSelectedMajor(majorId);
    setSelectedCandidates([]);
    setStep(3);
  };

  const handleCandidateToggle = (candidateId) => {
    if (selectedCandidates.includes(candidateId)) {
      setSelectedCandidates(selectedCandidates.filter(id => id !== candidateId));
    } else {
      if (selectedCandidates.length < 7) {
        setSelectedCandidates([...selectedCandidates, candidateId]);
      }
    }
  };

  const handleConfirmCandidates = () => {
    if (selectedCandidates.length >= 1 && selectedCandidates.length <= 7) {
      setStep(4);
    }
  };

  const handleSubmitVote = async (e) => {
    e.preventDefault();
    if (studentId && nationalId) {
      setIsSubmitting(true);
      const loadingId = messageBox.loading('در حال بررسی اطلاعات و ثبت رای شما...\nلطفاً صبر کنید و این صفحه را نبندید.');
      
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
        
        // First verify student credentials
        const verifyResponse = await fetch(`${BACKEND_URL}/api/auth/verify-student`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            student_id: studentId,
            national_id: nationalId
          })
        });
        
        if (!verifyResponse.ok) {
          const errorData = await verifyResponse.json();
          messageBox.hideMessage(loadingId);
          
          // Enhanced error messages with detailed guidance
          let errorMessage = errorData.detail || 'خطا در احراز هویت';
          
          // Customize error messages based on error type
          if (errorMessage.includes('اطلاعات دانشجویی یافت نشد')) {
            errorMessage = `<strong>اطلاعات دانشجویی یافت نشد</strong>\n\n• لطفاً شماره دانشجویی و کد ملی خود را دوباره بررسی کنید\n• مطمئن شوید که از اعداد انگلیسی استفاده می‌کنید\n• کد ملی باید دقیقاً 10 رقم باشد\n• در صورت ادامه مشکل با واحد فرهنگی تماس بگیرید`;
          } else if (errorMessage.includes('قبلاً در این انتخابات رای داده')) {
            errorMessage = `<strong>رأی تکراری</strong>\n\nشما قبلاً در این انتخابات رأی داده‌اید.\n\n• هر دانشجو فقط یک‌بار می‌تواند رأی دهد\n• رأی شما قبلاً با موفقیت ثبت شده است\n• در صورت نیاز به اصلاح رأی، با پشتیبانی تماس بگیرید`;
          } else if (errorMessage.includes('engineering')) {
            errorMessage = errorMessage.replace('engineering', 'دانشکده فنی و مهندسی');
          } else if (errorMessage.includes('humanities')) {
            errorMessage = errorMessage.replace('humanities', 'دانشکده علوم انسانی');
          } else if (errorMessage.includes('sports')) {
            errorMessage = errorMessage.replace('sports', 'دانشکده علوم ورزشی');
          }
          
          messageBox.error(errorMessage);
          setIsSubmitting(false);
          return;
        }
        
        // Submit vote
        const voteResponse = await fetch(`${BACKEND_URL}/api/vote/submit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            student_id: studentId,
            national_id: nationalId,
            selected_candidates: selectedCandidates,
            faculty: selectedFaculty,
            major: selectedMajor
          })
        });
        
        if (!voteResponse.ok) {
          const errorData = await voteResponse.json();
          messageBox.hideMessage(loadingId);
          
          // Enhanced error messages for vote submission
          let errorMessage = errorData.detail || 'خطا در ثبت رای';
          
          if (errorMessage.includes('فقط می‌توانید به نامزدهای دانشکده خود')) {
            errorMessage = `<strong>دانشکده نامطابق</strong>\n\n${errorMessage}\n\n• لطفاً به صفحه اصلی برگردید\n• دانشکده صحیح خود را انتخاب کنید`;
          } else if (errorMessage.includes('فقط می‌توانید به نامزدهای رشته خود')) {
            errorMessage = `<strong>رشته تحصیلی نامطابق</strong>\n\n${errorMessage}\n\n• لطفاً به مرحله قبل برگردید\n• رشته تحصیلی صحیح خود را انتخاب کنید`;
          } else if (errorMessage.includes('فاقد انجمن علمی')) {
            errorMessage = `<strong>رشته فاقد انجمن</strong>\n\n${errorMessage}\n\n• در صورت سوال با واحد فرهنگی دانشگاه تماس بگیرید`;
          } else if (errorMessage.includes('تعداد نامزدهای انتخابی')) {
            errorMessage = `<strong>تعداد نامزدها نامعتبر</strong>\n\nلطفاً حداقل 1 و حداکثر 7 نامزد را انتخاب کنید.\n\n• تعداد فعلی: ${selectedCandidates.length} نفر\n• به مرحله قبل برگردید و انتخاب را تصحیح کنید`;
          }
          
          // Format Persian faculty names
          if (errorMessage.includes('engineering')) {
            errorMessage = errorMessage.replace('engineering', 'دانشکده فنی و مهندسی');
          }
          if (errorMessage.includes('humanities')) {
            errorMessage = errorMessage.replace('humanities', 'دانشکده علوم انسانی');
          }
          if (errorMessage.includes('sports')) {
            errorMessage = errorMessage.replace('sports', 'دانشکده علوم ورزشی');
          }
          
          messageBox.error(errorMessage);
          setIsSubmitting(false);
          return;
        }
        
        const responseData = await voteResponse.json();
        messageBox.hideMessage(loadingId);
        messageBox.success(`<strong>رای شما با موفقیت ثبت شد!</strong>\n\nاز مشارکت شما در انتخابات انجمن‌های علمی دانشگاه شمال متشکریم.\n\n• رأی شما به صورت ایمن ذخیره شد\n• در چند لحظه دیگر به صفحه اصلی منتقل می‌شوید`, 4000);
        
        console.log('Vote submitted successfully:', responseData);
        
        setShowConfirmation(true);
        setIsSubmitting(false);
        
        setTimeout(() => {
          navigate('/');
        }, 4000);
      } catch (error) {
        messageBox.hideMessage(loadingId);
        messageBox.error(`<strong>خطا در ارتباط با سرور</strong>\n\nمتأسفانه ارتباط با سرور برقرار نشد.\n\n• لطفاً اتصال اینترنت خود را بررسی کنید\n• چند لحظه دیگر مجدداً تلاش کنید\n• در صورت ادامه مشکل با پشتیبانی تماس بگیرید`);
        setIsSubmitting(false);
      }
    }
  };

  const getCurrentMajor = () => {
    if (selectedFaculty && selectedMajor) {
      return facultiesData[selectedFaculty].majors.find(m => m.id === selectedMajor);
    }
    return null;
  };

  const getSelectedCandidatesData = () => {
    const major = getCurrentMajor();
    if (major) {
      return major.candidates.filter(c => selectedCandidates.includes(c.id));
    }
    return [];
  };

  const resetToStep = (targetStep) => {
    setStep(targetStep);
    if (targetStep === 1) {
      setSelectedFaculty(null);
      setSelectedMajor(null);
      setSelectedCandidates([]);
    } else if (targetStep === 2) {
      setSelectedMajor(null);
      setSelectedCandidates([]);
    } else if (targetStep === 3) {
      setSelectedCandidates([]);
    }
  };

  return (
    <div className="voting-page" data-testid="voting-page">
      {/* Header */}
      <div className="voting-header">
        <div className="container">
          <button className="back-to-home" onClick={() => navigate('/')} data-testid="back-home-btn">
            <i className="fas fa-home"></i>
            <span>بازگشت به صفحه اصلی</span>
          </button>
          <h1 data-testid="voting-page-title">سامانه رای‌گیری الکترونیک</h1>
          <p className="voting-subtitle">انتخابات انجمن‌های علمی دانشگاه شمال آمل ۱۴۰۴</p>
        </div>
      </div>

      {/* Progress Steps */}
      <div className="progress-container">
        <div className="container">
          <div className="progress-steps">
            <div className={`progress-step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'completed' : ''}`}>
              <div className="step-circle">
                {step > 1 ? <i className="fas fa-check"></i> : '1'}
              </div>
              <span className="step-label">انتخاب دانشکده</span>
            </div>
            <div className="progress-line"></div>
            <div className={`progress-step ${step >= 2 ? 'active' : ''} ${step > 2 ? 'completed' : ''}`}>
              <div className="step-circle">
                {step > 2 ? <i className="fas fa-check"></i> : '2'}
              </div>
              <span className="step-label">انتخاب رشته</span>
            </div>
            <div className="progress-line"></div>
            <div className={`progress-step ${step >= 3 ? 'active' : ''} ${step > 3 ? 'completed' : ''}`}>
              <div className="step-circle">
                {step > 3 ? <i className="fas fa-check"></i> : '3'}
              </div>
              <span className="step-label">انتخاب نامزد</span>
            </div>
            <div className="progress-line"></div>
            <div className={`progress-step ${step >= 4 ? 'active' : ''}`}>
              <div className="step-circle">4</div>
              <span className="step-label">تایید نهایی</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="voting-content">
        <div className="container">
          {/* Step 1: Faculty Selection */}
          {step === 1 && (
            <div className="selection-container" data-testid="faculty-selection">
              <h2 className="section-title">دانشکده خود را انتخاب کنید</h2>
              <div className="selection-grid">
                {Object.keys(facultiesData).map((facultyKey) => {
                  const faculty = facultiesData[facultyKey];
                  return (
                    <div
                      key={facultyKey}
                      className="selection-card"
                      onClick={() => handleFacultySelect(facultyKey)}
                      data-testid={`faculty-card-${facultyKey}`}
                    >
                      <div className="card-icon" style={{ backgroundColor: faculty.color }}>
                        <i className={`fas fa-${faculty.icon}`}></i>
                      </div>
                      <h3>{faculty.name}</h3>
                      <div className="card-info">
                        <i className="fas fa-graduation-cap"></i>
                        <span>{faculty.majors.length} رشته</span>
                      </div>
                      <button className="card-btn">
                        انتخاب دانشکده
                        <i className="fas fa-arrow-left"></i>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Step 2: Major Selection */}
          {step === 2 && selectedFaculty && (
            <div className="selection-container" data-testid="major-selection">
              <div className="section-header">
                <button className="back-btn" onClick={() => resetToStep(1)} data-testid="back-to-faculty-btn">
                  <i className="fas fa-arrow-right"></i>
                  بازگشت
                </button>
                <h2 className="section-title">رشته تحصیلی خود را انتخاب کنید</h2>
              </div>
              <div className="current-selection">
                <i className={`fas fa-${facultiesData[selectedFaculty].icon}`}></i>
                <span>{facultiesData[selectedFaculty].name}</span>
              </div>
              <div className="selection-grid">
                {facultiesData[selectedFaculty].majors.map((major) => (
                  <div
                    key={major.id}
                    className="selection-card"
                    onClick={() => handleMajorSelect(major.id)}
                    data-testid={`major-card-${major.id}`}
                  >
                    <div className="card-icon" style={{ backgroundColor: major.color }}>
                      <i className={`fas fa-${major.icon}`}></i>
                    </div>
                    <h3>{major.name}</h3>
                    <div className="card-info">
                      <i className="fas fa-users"></i>
                      <span>{major.candidates.length} نامزد</span>
                    </div>
                    <button className="card-btn">
                      مشاهده نامزدها
                      <i className="fas fa-arrow-left"></i>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Step 3: Candidates Selection */}
          {step === 3 && selectedMajor && (
            <div className="candidates-container" data-testid="candidates-selection">
              <div className="section-header">
                <button className="back-btn" onClick={() => resetToStep(2)} data-testid="back-to-major-btn">
                  <i className="fas fa-arrow-right"></i>
                  بازگشت
                </button>
                <h2 className="section-title">نامزدهای مورد نظر خود را انتخاب کنید</h2>
              </div>
              <div className="current-selection">
                <i className={`fas fa-${getCurrentMajor()?.icon}`}></i>
                <span>{getCurrentMajor()?.name}</span>
              </div>
              <div className="selection-info">
                <div className="info-badge">
                  <i className="fas fa-info-circle"></i>
                  <span>حداقل 1 و حداکثر 7 نامزد را انتخاب کنید</span>
                </div>
                <div className="selected-count">
                  <span>تعداد انتخاب شده:</span>
                  <strong>{selectedCandidates.length} / 7</strong>
                </div>
              </div>
              <div className="candidates-grid">
                {getCurrentMajor()?.candidates.map((candidate) => {
                  const isSelected = selectedCandidates.includes(candidate.id);
                  return (
                    <div
                      key={candidate.id}
                      className={`candidate-vote-card ${isSelected ? 'selected' : ''}`}
                      onClick={() => handleCandidateToggle(candidate.id)}
                      data-testid={`candidate-card-${candidate.id}`}
                    >
                      <div className="selection-checkbox">
                        {isSelected && <i className="fas fa-check"></i>}
                      </div>
                      <div className="candidate-vote-header">
                        <div className={`candidate-vote-avatar ${candidate.gender}`} style={{
                          width: '60px',
                          height: '60px',
                          flexShrink: 0,
                          overflow: 'hidden',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          {candidate.photo ? (
                            <img 
                              src={candidate.photo} 
                              alt={candidate.name}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'center'
                              }}
                            />
                          ) : (
                            <i className="fas fa-user"></i>
                          )}
                        </div>
                        <div className="candidate-vote-info">
                          <h4>{candidate.name}</h4>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="action-buttons">
                <button
                  className="btn btn-primary btn-large"
                  onClick={handleConfirmCandidates}
                  disabled={selectedCandidates.length < 1 || selectedCandidates.length > 7}
                  data-testid="confirm-candidates-btn"
                >
                  <i className="fas fa-check-circle"></i>
                  تایید و ادامه
                  <span className="btn-badge">{selectedCandidates.length}</span>
                </button>
              </div>
            </div>
          )}

          {/* Step 4: Credentials Form */}
          {step === 4 && !showConfirmation && (
            <div className="credentials-container" data-testid="credentials-form">
              <div className="section-header">
                <button className="back-btn" onClick={() => resetToStep(3)} data-testid="back-to-candidates-btn">
                  <i className="fas fa-arrow-right"></i>
                  بازگشت
                </button>
                <h2 className="section-title">اطلاعات دانشجویی</h2>
              </div>

              {/* Selected Candidates Summary */}
              <div className="selected-summary">
                <h3>نامزدهای انتخاب شده شما:</h3>
                <div className="summary-list">
                  {getSelectedCandidatesData().map((candidate, index) => (
                    <div key={candidate.id} className="summary-item">
                      <div className="summary-number">{index + 1}</div>
                      <div className={`summary-avatar ${candidate.gender}`} style={{
                        width: '50px',
                        height: '50px',
                        flexShrink: 0,
                        overflow: 'hidden',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {candidate.photo ? (
                          <img 
                            src={candidate.photo} 
                            alt={candidate.name}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              objectPosition: 'center'
                            }}
                          />
                        ) : (
                          <i className="fas fa-user"></i>
                        )}
                      </div>
                      <div className="summary-info">
                        <h4>{candidate.name}</h4>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Credentials Form */}
              <form className="credentials-form" onSubmit={handleSubmitVote}>
                <div className="form-group">
                  <label htmlFor="studentId">
                    <i className="fas fa-id-card"></i>
                    شماره دانشجویی
                  </label>
                  <input
                    type="text"
                    id="studentId"
                    value={studentId}
                    onChange={(e) => setStudentId(e.target.value)}
                    placeholder="مثال: 4001234567"
                    required
                    data-testid="student-id-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="nationalId">
                    <i className="fas fa-id-badge"></i>
                    کد ملی
                  </label>
                  <input
                    type="text"
                    id="nationalId"
                    value={nationalId}
                    onChange={(e) => setNationalId(e.target.value)}
                    placeholder="مثال: 1234567890"
                    required
                    maxLength="10"
                    data-testid="national-id-input"
                  />
                </div>

                <div className="form-warning">
                  <i className="fas fa-exclamation-triangle"></i>
                  <p>با ثبت رای، شماره دانشجویی و کد ملی شما جهت احراز هویت بررسی می‌شود. هر دانشجو فقط یکبار می‌تواند رای دهد.</p>
                </div>

                <button type="submit" className="btn btn-primary btn-large" data-testid="submit-vote-btn" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i>
                      در حال ثبت رای...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-vote-yea"></i>
                      ثبت نهایی رای
                    </>
                  )}
                </button>
              </form>
            </div>
          )}

          {/* Confirmation Message */}
          {showConfirmation && (
            <div className="confirmation-container" data-testid="confirmation-message">
              <div className="confirmation-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <h2>رای شما با موفقیت ثبت شد!</h2>
              <p>از مشارکت شما در انتخابات انجمن‌های علمی دانشگاه متشکریم.</p>
              <div className="confirmation-details">
                <div className="detail-item">
                  <span>رشته:</span>
                  <strong>{getCurrentMajor()?.name}</strong>
                </div>
                <div className="detail-item">
                  <span>تعداد نامزدهای انتخابی:</span>
                  <strong>{selectedCandidates.length} نفر</strong>
                </div>
              </div>
              <p className="redirect-message">در حال انتقال به صفحه اصلی...</p>
            </div>
          )}
        </div>
      </div>
      
      {/* Help Button */}
      <HelpButton />
    </div>
  );
};

export default VotingPage;